import {http} from "Services/Http/HttpClient";

export interface PaymentCard {
    id: string,
    name: string,
    expiryDate: string,
    isDefault: boolean,
}

export const getPaymentCards = async (tutorId: string): Promise<any> => {
    return await http.get(`tutors/${tutorId}/payment-cards`)
}

export const getPaymentCardFormHtml = async (): Promise<any> => {
    return await http.get(`tutors/payment-cards/redirect-url`)
}
